import React, { useState } from 'react';
import { Download, X } from 'lucide-react';
import { usePWAInstall } from '../../hooks/usePWA';

/**
 * Slide-up banner prompting the user to install the PWA.
 * Only shown when the browser fires `beforeinstallprompt`.
 */
const InstallPrompt: React.FC = () => {
  const { canInstall, install } = usePWAInstall();
  const [dismissed, setDismissed] = useState(false);

  if (!canInstall || dismissed) return null;

  const handleInstall = async () => {
    await install();
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-md animate-slide-up">
      <div className="flex items-center gap-3 rounded-xl bg-indigo-700 px-4 py-3 text-white shadow-lg">
        <Download className="h-5 w-5 shrink-0" />
        <p className="flex-1 text-sm font-medium">
          Install FET for a faster, app-like experience.
        </p>
        <button
          onClick={handleInstall}
          className="rounded-lg bg-white/20 px-3 py-1.5 text-xs font-semibold hover:bg-white/30 transition-colors"
        >
          Install
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="rounded-full p-1 hover:bg-white/20 transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;
